import {computed, ComputedRef, ref, Ref} from "vue";

export enum ReleazioDomainSettingTypes {
	DEFAULT = "default",
	DEV = "dev"
}

interface ReleazioDomainSetting {
	title: string;
	url: string;
	apiKey:  string;
}

export class ServiceReleazioApiSettings {
	private static _instance: ServiceReleazioApiSettings | null = null;
	private STORAGE_CUSTOM_API_KEY = 'releazio_custom_api_key';
	private STORAGE_PROP_API_KEY = 'releazio_prop_api_key';
	public prodApiUrl = import.meta.env.VITE_RELEAZIO_API_URL;
	public devApiUrl = import.meta.env.VITE_RELEAZIO_DEV_API_URL;
	public selectedDomainSettingProp: Ref<ReleazioDomainSettingTypes>;
	public domainSettings: Record<ReleazioDomainSettingTypes, ReleazioDomainSetting> = {
		default: {
			title: `Default (${this.prodApiUrl})`,
			url: this.prodApiUrl,
			apiKey: import.meta.env.VITE_RELEAZIO_API_AUTH_KEY
		},
		dev: {
			title: `Dev (${this.devApiUrl})`,
			url: this.devApiUrl,
			apiKey: import.meta.env.VITE_RELEAZIO_DEV_API_AUTH_KEY
		}
	};
	public selectedDomainSetting: ComputedRef<ReleazioDomainSetting>;
	public apiKey: Ref<string>;
	public customApiKey: Ref<string | null>;

	constructor() {
		this.selectedDomainSettingProp = ref(this.initDomainSettingByStorage());
		this.selectedDomainSetting = computed(() => this.domainSettings[this.selectedDomainSettingProp.value]);
		this.apiKey = ref(this.selectedDomainSetting.value.apiKey);
		this.customApiKey = ref(localStorage.getItem(this.STORAGE_CUSTOM_API_KEY));

		if (this.customApiKey.value && this.selectedDomainSettingProp.value === ReleazioDomainSettingTypes.DEV) {
			this.apiKey.value = this.customApiKey.value;
		}
	}

	private initDomainSettingByStorage(): ReleazioDomainSettingTypes {
		const localDomainSettingProp = localStorage.getItem(this.STORAGE_PROP_API_KEY);

		if (localDomainSettingProp !== null) {
			if (Object.values(ReleazioDomainSettingTypes).includes(localDomainSettingProp as ReleazioDomainSettingTypes)) {
				return localDomainSettingProp as ReleazioDomainSettingTypes;
			}
		}

		return ReleazioDomainSettingTypes.DEFAULT;
	}

	public updateReleazioSettings(value: ReleazioDomainSettingTypes) {
		this.selectedDomainSettingProp.value = value;

		if (value === ReleazioDomainSettingTypes.DEFAULT) {
			this.apiKey.value = this.domainSettings[value].apiKey;
		} else {
			this.apiKey.value = this.customApiKey.value !== null ? this.customApiKey.value : this.domainSettings[value].apiKey;
		}

		localStorage.setItem(this.STORAGE_PROP_API_KEY, value)
	}

	public resetReleazioCustomSettings() {
		this.apiKey.value = this.selectedDomainSetting.value.apiKey;
		localStorage.removeItem(this.STORAGE_CUSTOM_API_KEY);
		this.customApiKey.value = null;
	}

	public saveReleazioCustomSettings() {
		this.customApiKey.value = this.apiKey.value;
		localStorage.setItem(this.STORAGE_CUSTOM_API_KEY, this.customApiKey.value);
	}

	public static of() {
		if (ServiceReleazioApiSettings._instance === null) {
			ServiceReleazioApiSettings._instance = new ServiceReleazioApiSettings()
		}

		return ServiceReleazioApiSettings._instance;
	}
}
